import { useEnvContext } from "next-runtime-env";
import { useEffect } from "react";

export const useSetEnv = () => {
  const {
    NEXT_PUBLIC_EJ_APPS_API_HOSTNAME,
    NEXT_PUBLIC_EJ_APPS_LOCATION_API_HOSTNAME,
    NEXT_PUBLIC_EJ_APPS_SEARCH_API,
    NEXT_PUBLIC_EJ_APP_CANONICAL_HOST,
    NEXT_PUBLIC_EJ_APPS_PANEL_HOSTNAME,
    NEXT_PUBLIC_EJ_KEYS_RECAPTCHA,
    NEXT_PUBLIC_URL_MAKER_ADDRESS,
    NEXT_PUBLIC_EJ_APPS_CMS_HOSTNAME,
    NEXT_PUBLIC_EJ_APPS_FEATURE_CONTROL,
  } = useEnvContext();

  useEffect(() => {
    if (window && typeof window !== "undefined") {
      window.env = {
        EJ_APPS_API_HOSTNAME: NEXT_PUBLIC_EJ_APPS_API_HOSTNAME,
        EJ_APPS_LOCATION_API_HOSTNAME: NEXT_PUBLIC_EJ_APPS_LOCATION_API_HOSTNAME,
        EJ_APPS_SEARCH_API: NEXT_PUBLIC_EJ_APPS_SEARCH_API,
        EJ_APP_CANONICAL_HOST: NEXT_PUBLIC_EJ_APP_CANONICAL_HOST,
        EJ_APPS_PANEL_HOSTNAME: NEXT_PUBLIC_EJ_APPS_PANEL_HOSTNAME,
        EJ_KEYS_RECAPTCHA: NEXT_PUBLIC_EJ_KEYS_RECAPTCHA,
        URL_MAKER_ADDRESS: NEXT_PUBLIC_URL_MAKER_ADDRESS,
        EJ_APPS_CMS_HOSTNAME: NEXT_PUBLIC_EJ_APPS_CMS_HOSTNAME,
        EJ_APPS_FEATURE_CONTROL: NEXT_PUBLIC_EJ_APPS_FEATURE_CONTROL,
      };
    }
  }, [
    NEXT_PUBLIC_EJ_APPS_API_HOSTNAME,
    NEXT_PUBLIC_EJ_APPS_LOCATION_API_HOSTNAME,
    NEXT_PUBLIC_EJ_APPS_SEARCH_API,
    NEXT_PUBLIC_EJ_APPS_CMS_HOSTNAME,
  ]);
};
